export default __webpack_public_path__ + "static/media/hbs-cbb-poster-3.8013839c.jpg";